/* ==========================================================================
   duvelle-anchor.js
   Defilement doux vers une section de la page, avec compensation de l'en-tete
   colle en haut. Un seul ecouteur delegue, pose une fois : il survit aux
   rechargements de sections dans l'editeur de theme.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__duvelleAnchorBound) return;
  window.__duvelleAnchorBound = true;

  function headerOffset() {
    var declared = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height');
    var value = parseFloat(declared);
    if (!isNaN(value) && value > 0) return value + 12;

    var header = document.querySelector('header');
    if (header) {
      var position = getComputedStyle(header).position;
      if (position === 'sticky' || position === 'fixed') {
        return header.getBoundingClientRect().height + 12;
      }
    }
    return 16;
  }

  function scrollToElement(element) {
    var top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    top = Math.max(0, Math.round(top));

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    } catch (error) {
      window.scrollTo(0, top);
    }

    /* Filet de securite : si l'animation ne s'execute pas, on force la
       position finale pour que le clic aboutisse quoi qu'il arrive. */
    window.setTimeout(function () {
      if (Math.abs(window.pageYOffset - top) > 4) window.scrollTo(0, top);
    }, 700);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-dv-scroll-to]');
    if (!trigger) return;

    var selector = trigger.getAttribute('data-dv-scroll-to');
    if (!selector) return;

    var destination;
    try {
      destination = document.querySelector(selector);
    } catch (error) {
      return; /* selecteur invalide : on laisse le lien se comporter normalement */
    }
    if (!destination) return;

    event.preventDefault();
    scrollToElement(destination);

    /* Le lecteur d'ecran suit le deplacement. */
    destination.setAttribute('tabindex', '-1');
    destination.focus({ preventScroll: true });
  });
})();
